import { useParams } from "react-router-dom";
import DeepLinkRedirect from "../components/DeepLinkRedirect";

export default function MealPreviewRedirect() {
  const { mealId } = useParams();
  return <DeepLinkRedirect path={`MealPreview`} query={{ mealId }} />;
}
